module.exports = __webpack_public_path__ + "static/media/iris_smart_city_company.35f3148c.png";